import { memo } from "react";

import styles from "./TijdlijnSchaal.module.css";
import { TijdlijnSchaalMinuten } from "./TijdlijnSchaalMinuten";
import { DateTime } from "luxon";
import { usePersoneelsdienstenStore } from "@personeel/stores/PersoneelsdienstenStore.ts";

interface ITijdlijnSchaal {
  start: DateTime;
  eind: DateTime;
  scale?: number;
}

export const TijdlijnSchaal = memo(function TijdlijnSchaal({
  start,
  eind,
  scale = 12,
}: Readonly<ITijdlijnSchaal>) {
  const tijdlijnLengteMinuten = (eind.toUnixInteger() - start.toUnixInteger()) / 60;
  const diensten = usePersoneelsdienstenStore((state) => state.personeelsdiensten);

  // gridTemplateColumns moet een heel getal zijn. Daarom wordt er naar boven afgerond
  const columns = Math.ceil(tijdlijnLengteMinuten / 2);

  const isStartOneven = start.minute % 2 !== 0;
  // Elke kolom is 2 minuten (scale*2 px), dus 1 minuut = halve kolom (scale px).
  // Bij een oneven start wordt er 'scale' pixels als padding gebruikt voor juiste uitlijning.
  const pixelOffset = isStartOneven ? scale : 0;

  return (
    <div
      className={styles["tijdlijn"]}
      style={{
        gridTemplateColumns: `repeat(${columns}, ${scale * 2}px)`,
        gridTemplateRows: diensten.length * 80 + "px",
        height: "7px",
        paddingLeft: pixelOffset,
      }}
    >
      <TijdlijnSchaalMinuten start={start} eind={eind} scale={scale} />
    </div>
  );
});
